var path = 'scripts/views/directives/flash-message.html';
var html = "<div ng-show=\"displayFlashMessage\"\n     class=\"alert alert-success alert-dismissible\"\n     role=\"alert\">\n    <button type=\"button\"\n            class=\"close\"\n            data-dismiss=\"alert\"\n            aria-label=\"Close\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <strong translate>directives.flashMessage.ReceiptSuccessfullyMatched</strong>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/directives/flash-message.html
// module id = 377
// module chunks = 0